import React from 'react';
import _ from 'lodash';

export const renderTabCount = (entity, directCount = false) => {
  if (typeof entity === 'object' || Array.isArray(entity)) {
    entity = _.filter(
      entity,
      object =>
        typeof object.deleted_at === 'undefined' || object.deleted_at === null,
    );
  }

  if (directCount === true) {
    if (typeof entity === 'undefined') {
      return 0;
    } else if (typeof entity === 'number' && entity !== 0) {
      return entity;
    } else if (typeof entity === 'object' && Object.keys(entity).length !== 0) {
      return Object.keys(entity).length;
    } else if (Array.isArray(entity) && entity.length > 0) {
      return Object.keys(entity).length;
    }
    return 0;
  }

  if (typeof entity === 'undefined') {
    return <span />;
  } else if (typeof entity === 'number' && entity !== 0) {
    return <span className="count">{entity}</span>;
  } else if (typeof entity === 'object' && Object.keys(entity).length !== 0) {
    return <span className="count">{Object.keys(entity).length}</span>;
  } else if (Array.isArray(entity) && entity.length > 0) {
    return <span className="count">{Object.keys(entity).length}</span>;
  }

  return <span />;
};



// WEBPACK FOOTER //
// ./src/helpers/renderTabCount.js